import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Row,
  Table,
  Card,
  Dropdown,
} from "react-bootstrap";
// import WhatsAppAPI from "../../api/WhatsAppAPI";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import Confirm from "../Confirm";
import { useNavigate } from "react-router-dom";
import Confirm from "../../Confirm";
import { ShimmerTable } from "react-shimmer-effects";
import { motion } from "framer-motion";
import SparkApi from "../../../api/SparkApi";
import { FaPlus } from "react-icons/fa";
import "../WatConnect.css";

const Addon = () => {
  const navigate = useNavigate();
  const [body, setBody] = useState([]);
  const [isSpinner, setIsSpinner] = useState(false);
  const [rowData, setRowData] = useState(null);
  const [showHideModel, setShowHideModel] = useState(false);
  const [showHideStatusModel, setShowHideStatusModel] = useState(false);
  const VISIBLE_COLUMNS_KEY = "visible_columns_preferences";

  useEffect(() => {
    (async () => {
      const result = await SparkApi.getAllAddons();
      if (result.success) setBody(result.records);
      else setBody([]);
      setIsSpinner(true);
    })();
  }, []);

  const optionalColumns = [
    { title: "Price Per Monthly", prop: "monthly", isFilterable: true, cell: (r) => `₹${r?.monthly || "N/A"}` },
    { title: "Price Per Quarter", prop: "quarterly", isFilterable: true, cell: (r) => `₹${r?.quarterly || "N/A"}` },
    { title: "Price Per Half Year", prop: "half_yearly", isFilterable: true, cell: (r) => `₹${r?.half_yearly || "N/A"}` },
    { title: "Price Per Year", prop: "yearly", isFilterable: true, cell: (r) => `₹${r?.yearly || "N/A"}` },
    { title: "Unit", prop: "unit", isFilterable: true, cell: (r) => r?.unit || "" },
  ];

  const defaultHiddenColumns = ["unit"];

  const getInitialVisibleColumns = () => {
    const saved = sessionStorage.getItem(VISIBLE_COLUMNS_KEY);
    if (saved) return JSON.parse(saved);
    return optionalColumns.reduce((acc, col) => {
      acc[col.prop] = !defaultHiddenColumns.includes(col.prop);
      return acc;
    }, {});
  };

  const [visibleColumns, setVisibleColumns] = useState(getInitialVisibleColumns);

  useEffect(() => {
    sessionStorage.setItem(VISIBLE_COLUMNS_KEY, JSON.stringify(visibleColumns));
  }, [visibleColumns]);

  const toggleColumn = (col) => {
    setVisibleColumns((prev) => ({ ...prev, [col]: !prev[col] }));
  };

  const fixedColumns = [
    { title: "Name", prop: "name", isFilterable: true, isSortable: true, cell: (r) => r?.name || "" },
    {
      title: "Actions",
      prop: "id",
      cell: (r) => (
        <>
          <Button className="btn-sm mx-2" onClick={() => navigate(`/addon/${r.id}/e`, { state: r })}>
            <i className="fa-solid fa-pen-to-square" title="Edit" />
          </Button>
          <Button className="btn-sm mx-2" variant="danger" onClick={() => { setRowData(r); setShowHideModel(true); }}>
            <i className="fa-regular fa-trash-can" title="Delete" />
          </Button>
        </>
      ),
    },
  ];

  const columnsToShow = [
    fixedColumns[0],
    ...optionalColumns.filter((col) => visibleColumns[col.prop]),
    fixedColumns[1],
  ];

  const changeStatus = async () => {
    try {
      const newStatus = rowData.status === "active" ? "inactive" : "active";
      const response = await SparkApi.updatePlanRecord({ ...rowData, status: newStatus });
      if (response.success) {
        setShowHideStatusModel(false);
        toast.success("Plan status updated successfully.");
        const result = await SparkApi.getAllAddons();
        if (result.success) setBody(result.records);
      } else {
        toast.error(response);
      }
    } catch (error) {
      // error handling
    }
  };

  const deleteAddonRecord = async () => {

    if (!rowData?.id) return;
    const result = await SparkApi.deleteAddonRecord(rowData.id);
    console.log("adddon",result);
    if (result.success) {
      const updated = await SparkApi.getAllAddons();
      if (updated.success) setBody(updated.records);
      setShowHideModel(false);
    } else {
      toast.error(result.error?.message);
    }
  };

  return (
    <>
      {/* {isSpinner ? ( */}
      <Container className="mt-5 mb-5">
        <Row className="mx-5 mb-4">
          <Card className="p-4 bg-white shadow-sm border-0 rounded-3">
            <h5 className="mb-2 fw-bold">💡 Quick Guide</h5>
            <small className="text-muted">
              This section allows you to manage all addon services. You can view, filter, customize columns, and perform actions such as edit, delete, or update status efficiently.
            </small>
          </Card>
        </Row>

        <Row className="mx-5 g-0">
          <Col lg={12} className="mb-3">
            <div className="bg-white shadow-sm border-0 rounded-3 p-4">
              <h5 className="fw-semibold mb-3 d-flex align-items-center gap-2">
                <motion.span
                  animate={{ scale: [1, 1.4, 1.1, 1.4, 1] }}
                  transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
                  className="text-5xl"
                >
                  ✨
                </motion.span>
                Addons Records
              </h5>

              <DatatableWrapper body={body} headers={columnsToShow} paginationOptionsProps={{ initialState: { rowsPerPage: 10, options: [5, 10, 15, 20] } }}>
                <Row className="mb-3">
                  <Col lg={3} sm={10} xs={10} className="d-flex flex-col justify-content-end align-items-end">
                    <Filter className="p-2" />
                  </Col>
                  <Col lg={4} sm={2} xs={2} className="d-flex justify-content-start">
                    <PaginationOptions labels={{ beforeSelect: " " }} />
                  </Col>
                  <Col lg={5} sm={12} xs={12} className="mt-2 d-flex justify-content-end align-items-center gap-2">
                    {/* <Button className="fw-semibold p-1"
                      size="sm" onClick={() => navigate("/addon/add")}>
                      <FaPlus />  Add New Addon
                    </Button> */}

                    <Button
                      className="btn-sm text-dark"
                      variant="outline-primary mx-2"
                      onClick={() => navigate("/addon/add")}
                    >
                      <FaPlus size={10} className="me-1" /> Add New Addon
                    </Button>
                    <Dropdown>
                      <Dropdown.Toggle variant="secondary" size="sm" className="custom-dropdown-toggle text-dark">
                        <i className="fa fa-angle-double-down" style={{ fontSize: "15px" }}></i>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {optionalColumns.map((col) => (
                          <Dropdown.Item
                            key={col.prop}
                            as="label"
                            htmlFor={`col-checkbox-${col.prop}`}
                            className="d-flex align-items-center px-3 py-2"
                            style={{ cursor: "pointer", userSelect: "none" }}
                          >
                            <input
                              id={`col-checkbox-${col.prop}`}
                              type="checkbox"
                              checked={visibleColumns[col.prop]}
                              onChange={() => toggleColumn(col.prop)}
                              onClick={(e) => e.stopPropagation()}
                              style={{ marginRight: "0.5rem" }}
                            />
                            {col.title}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </Col>
                </Row>

                <div className="table-responsive">
                  <Table bordered hover className="custom-table align-middle">
                    <TableHeader />
                    <TableBody />
                  </Table>
                </div>
                <Pagination />
              </DatatableWrapper>
            </div>
          </Col>
        </Row>
      </Container>
      {/* ) : (
        <div className="sk-cube-grid">
          {[...Array(9)].map((_, i) => (
            <div key={i} className={`sk-cube sk-cube${i + 1}`} />
          ))}
        </div>
      )} */}

      <ToastContainer />
      {showHideModel && (
        <Confirm
          show={showHideModel}
          onHide={() => setShowHideModel(false)}
          deleteAddonRecord={deleteAddonRecord}
          title="Confirm delete?"
          message="You are going to delete the record. Are you sure?"
          table="addon"
        />
      )}
      {showHideStatusModel && (
        <Confirm
          show={showHideStatusModel}
          onHide={() => setShowHideStatusModel(false)}
          changeStatus={changeStatus}
          title="Confirm status change?"
          message="Are you sure you want to change the plan's status?"
          table="plan_status"
        />
      )}
    </>
  );
};

export default Addon;
